// utils/ratio.ts
export function ratioToNumber(r: string): number {
  const [w, h] = r.split(":").map(Number);
  return w > 0 && h > 0 ? w / h : 16 / 9; // safe fallback
}
